exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QRCodeModal_modalContent_3Jttq {\n    width: -webkit-min-content;\n    width: -moz-min-content;\n    width: min-content;\n    background-repeat: no-repeat;\n    border: none;\n    padding-top: 5%;\n}\n", ""]);

// exports
exports.locals = {
	"modalContent": "QRCodeModal_modalContent_3Jttq"
};